"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const icon_1 = __importDefault(require("../icon"));
const styles_1 = require("./styles");
const { SuccessIcon, CloseButton } = icon_1.default;
const RotaInputNew = (0, react_1.forwardRef)((_a, ref) => {
    var { id, label, placeholder, errorMessage, helperText, isError = false, isSuccess = false, isDisabled = false, onChange, saveOnBlur, value, iconLeft, iconRight, wrapperStyles, isRightAligned, prefix } = _a, props = __rest(_a, ["id", "label", "placeholder", "errorMessage", "helperText", "isError", "isSuccess", "isDisabled", "onChange", "saveOnBlur", "value", "iconLeft", "iconRight", "wrapperStyles", "isRightAligned", "prefix"]);
    const theme = (0, styled_components_1.useTheme)();
    let icon = iconRight;
    if (isError || errorMessage) {
        icon = react_1.default.createElement(CloseButton, { color: theme.error.main });
    }
    else if (isSuccess) {
        icon = react_1.default.createElement(SuccessIcon, { color: theme.success.main });
    }
    let icon2 = iconLeft;
    if (prefix) {
        icon2 = react_1.default.createElement(react_1.default.Fragment, null, prefix);
    }
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const hasValue = ![undefined, null, ""].includes(value);
    return (react_1.default.createElement(styles_1.Wrapper, { style: Object.assign({}, wrapperStyles), isError: isError || !!errorMessage, isSuccess: isSuccess, isDisabled: isDisabled, isFocused: isFocused },
        react_1.default.createElement(styles_1.InputWithLabelWrapper, null,
            label && (react_1.default.createElement(styles_1.Label, { isFocused: isFocused, htmlFor: id, isSuccess: isSuccess, isError: isError || !!errorMessage, isDisabled: isDisabled, hasValue: hasValue, theme: theme }, label)),
            react_1.default.createElement(styles_1.InputWithErrorMessage, null,
                react_1.default.createElement(styles_1.InputWithIcons, { isError: isError || !!errorMessage, isSuccess: isSuccess, isFocused: isFocused, isDisabled: isDisabled },
                    icon2 && (react_1.default.createElement(styles_1.IconWrapper, { isFocused: isFocused, hasValue: hasValue, style: { marginLeft: 12 } }, icon2)),
                    react_1.default.createElement(styles_1.InputWrapper, null,
                        react_1.default.createElement(styles_1.Input, Object.assign({ id: id, ref: ref, placeholder: placeholder, onChange: onChange, value: value, disabled: isDisabled, isRightAligned: isRightAligned }, props, { onFocus: () => setIsFocused(true), onBlur: () => __awaiter(void 0, void 0, void 0, function* () {
                                setIsFocused(false);
                                if (saveOnBlur) {
                                    yield saveOnBlur({ value });
                                }
                            }) }))),
                    icon && (react_1.default.createElement(styles_1.IconWrapper, { isFocused: isFocused, hasValue: hasValue, style: { marginRight: 12 } }, icon))),
                errorMessage && react_1.default.createElement(styles_1.ErrorMessage, null, errorMessage),
                helperText && !errorMessage && (react_1.default.createElement(styles_1.HelperText, null, helperText))))));
});
exports.default = RotaInputNew;
